export const messages = {
  en: {
    propertyCompanyManage: {
      queryCondition: 'Query Conditions',
      propertyCompany: 'Property Company',
      search: 'Search',
      reset: 'Reset',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      login: 'Login',
      restrictLogin: 'Restrict Login',
      restoreLogin: 'Restore Login',
      resetPwd: 'Reset Password',
      manageCommunity: 'Manage Community',
      enterStoreId: 'Please enter store ID',
      enterName: 'Please enter name',
      enterTel: 'Please enter telephone',
      storeId: 'Store ID',
      name: 'Name',
      address: 'Address',
      tel: 'Telephone',
      corporation: 'Corporation',
      foundingTime: 'Founding Time',
      landmark: 'Landmark',
      createTime: 'Create Time',
      operation: 'Operation',
      tip: 'Tip: Default admin account is mobile number, password is mobile number',
      fetchError: 'Failed to fetch property company list',
      fetchStaffError: 'Failed to fetch staff information',
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete property company',
      confirmUpdateState: 'Confirm to',
      confirmResetPwd: 'Confirm to reset password',
      passwordConfirm: 'Password Confirmation',
      password: 'Password',
      enterCurrentPassword: 'Please enter current account password',
      passwordRequired: 'Password is required',
      selectCommunities: 'Please select communities',
      functions: 'Functions',
      all: 'All',
      communities: 'Communities',
      addSuccess: 'Add successfully',
      editSuccess: 'Edit successfully',
      deleteSuccess: 'Delete successfully',
      updateSuccess: 'Update successfully',
      resetPwdSuccess: 'Reset password successfully, new password is {pwd}, please change it in time',
      fetchMenuError: 'Failed to fetch menu groups',
      fetchCommunityError: 'Failed to fetch communities',
      selectAccount: 'Select Account',
      belongTo: 'Belong To',
      role: 'Role',
      selectUserFirst: 'Please select a user first',
      noCommunityAssigned: 'No community assigned',
      validate: {
        name: 'Name cannot be empty',
        address: 'Address cannot be empty',
        tel: 'Telephone cannot be empty',
        corporation: 'Corporation cannot be empty',
        foundingTime: 'Founding time cannot be empty',
        nearbyLandmarks: 'Landmark cannot be empty'
      }
    }
  },
  zh: {
    propertyCompanyManage: {
      queryCondition: '查询条件',
      propertyCompany: '物业公司',
      search: '查询',
      reset: '重置',
      add: '添加',
      edit: '修改',
      delete: '删除',
      login: '登录',
      restrictLogin: '限制登录',
      restoreLogin: '恢复登录',
      resetPwd: '重置密码',
      manageCommunity: '管理园区',
      enterStoreId: '请输入物业编号',
      enterName: '请输入名称',
      enterTel: '请输入电话',
      storeId: '编号',
      name: '名称',
      address: '地址',
      tel: '电话',
      corporation: '公司法人',
      foundingTime: '成立日期',
      landmark: '地标',
      createTime: '创建时间',
      operation: '操作',
      tip: '温馨提示：默认管理员账号为手机号；密码为手机号',
      fetchError: '获取物业公司列表失败',
      fetchStaffError: '获取员工信息失败',
      confirmOperation: '请确认您的操作',
      confirmDelete: '确定删除物业公司',
      confirmUpdateState: '确认是否',
      confirmResetPwd: '确认是否重置密码',
      passwordConfirm: '密码确认',
      password: '密码',
      enterCurrentPassword: '必填，请输入当前账号密码',
      passwordRequired: '密码不能为空',
      selectCommunities: '请选择开通园区',
      functions: '功能',
      all: '全部',
      communities: '园区',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '删除成功',
      updateSuccess: '更新成功',
      resetPwdSuccess: '修改密码成功，密码为{pwd}请及时修改密码',
      fetchMenuError: '获取菜单组失败',
      fetchCommunityError: '获取园区信息失败',
      selectAccount: '选择账号',
      belongTo: '所属',
      role: '角色',
      selectUserFirst: '请先选择用户',
      noCommunityAssigned: '未分配园区',
      validate: {
        name: '名称不能为空',
        address: '地址不能为空',
        tel: '电话不能为空',
        corporation: '公司法人不能为空',
        foundingTime: '成立日期不能为空',
        nearbyLandmarks: '地标不能为空'
      }
    },
  },
  'zh-TW': {
    propertyCompanyManage: {
      queryCondition: '查詢條件',
      propertyCompany: '物业公司',
      search: '查詢',
      reset: '重置',
      add: '添加',
      edit: '修改',
      delete: '刪除',
      login: '登錄',
      restrictLogin: '限制登錄',
      restoreLogin: '恢復登錄',
      resetPwd: '重置密碼',
      manageCommunity: '管理小區',
      enterStoreId: '請輸入物业編號',
      enterName: '請輸入名稱',
      enterTel: '請輸入電話',
      storeId: '編號',
      name: '名稱',
      address: '地址',
      tel: '電話',
      corporation: '公司法人',
      foundingTime: '成立日期',
      landmark: '地標',
      createTime: '創建時間',
      operation: '操作',
      tip: '溫馨提示：默認管理員賬號為手機號；密碼為手機號',
      fetchError: '獲取物业公司列表失敗',
      fetchStaffError: '獲取員工信息失敗',
      confirmOperation: '請確認您的操作',
      confirmDelete: '確定刪除物业公司',
      confirmUpdateState: '確認是否',
      confirmResetPwd: '確認是否重置密碼',
      passwordConfirm: '密碼確認',
      password: '密碼',
      enterCurrentPassword: '必填，請輸入當前賬號密碼',
      passwordRequired: '密碼不能為空',
      selectCommunities: '請選擇開通小區',
      functions: '功能',
      all: '全部',
      communities: '小區',
      addSuccess: '添加成功',
      editSuccess: '修改成功',
      deleteSuccess: '刪除成功',
      updateSuccess: '更新成功',
      resetPwdSuccess: '修改密碼成功，密碼為{pwd}請及時修改密碼',
      fetchMenuError: '獲取菜單組失敗',
      fetchCommunityError: '獲取小區信息失敗',
      selectAccount: '選擇賬號',
      belongTo: '所屬',
      role: '角色',
      selectUserFirst: '請先選擇用戶',
      noCommunityAssigned: '未分配小區',
      validate: {
        name: '名稱不能為空',
        address: '地址不能為空',
        tel: '電話不能為空',
        corporation: '公司法人不能為空',
        foundingTime: '成立日期不能為空',
        nearbyLandmarks: '地標不能為空'
      }
    },
  }
}